__turbopack_context__.v({
  "helios-video-modal": "pO7teq_helios-video-modal",
  "helios-video-modal__close": "pO7teq_helios-video-modal__close",
  "helios-video-modal__media": "pO7teq_helios-video-modal__media",
  "helios-video-modal__player": "pO7teq_helios-video-modal__player",
});
